import { styled } from 'styled-components';
import { IArticleBox5, defaultParams } from './params';
import { IGlobaVariables } from '../../Layout/styles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IArticleBox5;
}>`
  .article-box {
    position: relative;
    display: flex;
    gap: 15px;
    padding: 20px 17px 21px;
    height: 100%;
    border: ${({ $config: styles }) => styles.border};
    border-radius: ${({ $config: styles }) => styles.borderRadius};
    background: ${({ $config: styles }) => styles.backgroundColor};
    box-shadow: ${({ $config: styles }) => styles.boxShadow};

    &-image {
      width: 90px;
      height: 90px;
      min-width: 90px;
      min-height: 90px;

      @media (min-width: ${({ theme }) => theme.breakpoint.sm}) {
        width: 152px;
        height: 152px;
        min-width: 152px;
        min-height: 152px;
      }

      border-radius: ${({ $config: styles }) => styles.borderRadius};
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-content {
      position: relative;
      padding: 0;
      word-break: break-word;
    }

    &-category {
      padding: 7px 0 0 0;
      display: block;
      color: ${({ $config: styles }) => styles.group_category.color};
      font-family: ${({ $config: styles }) => styles.group_category.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_category.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_category.fontSize};
      line-height: ${({ $config: styles }) => styles.group_category.lineHeight};
      text-decoration: ${({ $config: styles }) => styles.group_category.textDecoration};
      text-align: ${({ $config: styles }) => styles.group_category.textAlign};
      margin-bottom: 12px;
      transition: all 0.2s ease-in;
      &:hover {
        color: ${({ $config: styles }) => styles.group_category.hover_color};
        text-decoration: ${({ $config: styles }) => styles.group_category.hover_textDecoration};
      }

      &.disabled {
        pointer-events: none;
        color: ${({ $config: styles }) => styles.group_category.group_category_disabled.color};
        text-decoration: ${({ $config: styles }) => styles.group_category.group_category_disabled.textDecoration};
      }
    }

    &-title {
      line-height: ${({ $config: styles }) => styles.group_title.lineHeight};
      margin-bottom: 12px;

      a {
        color: ${({ $config: styles }) => styles.group_title.color};
        font-family: ${({ $config: styles }) => styles.group_title.fontFamily};
        font-style: ${({ $config: styles }) => styles.group_title.fontStyle};
        font-weight: ${({ $config: styles }) => styles.group_title.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_title.fontSize};
        text-decoration: ${({ $config: styles }) => styles.group_title.textDecoration};
        text-align: ${({ $config: styles }) => styles.group_title.textAlign};

        &:hover {
          color: ${({ $config: styles }) => styles.group_title.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_title.hover_textDecoration};
        }
      }

      min-height: 60px;
      @media (min-width: ${({ theme }) => theme.breakpoint.sm}) {
        min-height: initial;
      }
    }

    &-description {
      color: ${({ $config: styles }) => styles.group_description.color};
      font-family: ${({ $config: styles }) => styles.group_description.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_description.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_description.fontSize};
      line-height: ${({ $config: styles }) => styles.group_description.lineHeight};
      text-align: ${({ $config: styles }) => styles.group_description.textAlign};
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow-wrap: break-word;
      overflow: hidden;
      margin: 0 0 25px 0;

      transform: translateX(-105px);
      width: calc(100% + 105px);
      @media (min-width: ${({ theme }) => theme.breakpoint.sm}) {
        transform: translateX(0);
        width: 100%;
      }
    }

    &-button {
      position: absolute;
      bottom: -22.5px;
      right: 30px;
      padding: 11px 20px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: max-content;
      height: 45px;
      background: ${({ $config: styles }) => styles.group_button.backgroundColor};
      border: ${({ $config: styles }) => styles.group_button.border};
      border-radius: ${({ $config: styles }) => styles.group_button.borderRadius};
      text-decoration: ${({ $config: styles }) => styles.group_button.textDecoration};
      color: ${({ $config: styles }) => styles.group_button.color};
      transition: 0.2s all ease-in;
      box-sizing: border-box;
      svg {
        width: 20px;
        height: 20px;
        transition: transform 0.2s ease-in;
      }
      &:hover {
        background: ${({ $config: styles }) => styles.group_button.hover_backgroundColor};
        border: ${({ $config: styles }) => styles.group_button.hover_border};
        border-radius: ${({ $config: styles }) => styles.group_button.hover_borderRadius};
        color: ${({ $config: styles }) => styles.group_button.hover_color};
        text-decoration: ${({ $config: styles }) => styles.group_button.hover_textDecoration};
      }
    }
  }
`;

export default Styles;
